import type { NavigationGuardWithThis } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

/**
 * 路由守卫
 * - 未登录访问需要认证的页面 → 跳转登录
 * - 已登录访问登录/注册页 → 跳转主页
 */
export const authGuard: NavigationGuardWithThis<undefined> = (to, _from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 商季` : '商季';

  const authStore = useAuthStore();
  const requiresAuth = to.meta.requiresAuth !== false;
  const isAuthPage = to.name === 'Login' || to.name === 'Register' || to.name === 'QrCodeLogin';

  if (requiresAuth && !authStore.isLoggedIn) {
    next({ name: 'Login' });
    return;
  }

  if (isAuthPage && authStore.isLoggedIn) {
    next({ name: 'Main' });
    return;
  }

  next();
};
